const validateForm = ($fields, force) =>
  new Promise(resolve => {
    if (force) {
      $fields.parent().removeClass('pristine');
    }
    const $invalidFields = Array.from($fields).reduce((collection, field) => {
        if (field.getAttribute('type') === 'email') {
            if (field.value.match(/^.+@.+\..+$/)) {
                return collection;
            }
        }
        else if (field.getAttribute('type') === 'checkbox') {
            if (field.checked) {
                return collection;
            }
        }
        else if (field.getAttribute('type') === 'number') {
            if (field.value.match(/^\d+$/)) {
                return collection;
            }
        }
        else if (field.value) {
        return collection;
      }
      return [...collection, field];
    }, []);
    resolve({
      valid: !$invalidFields.length,
      invalidFields: $invalidFields
    });
  });

export default validateForm;
